import { createContext, useContext } from "react";

type ChatFindHighlightContextType = {
  /** The "Find in conversation" match currently stepped to; null when the bar is closed. */
  highlightedMessageId: string | null;
  setHighlightedMessageId: (messageId: string | null) => void;
};

/**
 * Persistent highlight for the current "Find in conversation" match. The SDK's own highlight
 * (jumpToMessage → highlightedMessageId) is a timed flash that clears itself; this one stays on
 * the current match until the user steps or closes the bar. Read by ChatMessageWithDisclosedName,
 * which sets the message context's `highlighted` so MessageSimple applies its highlighted style.
 * Defaults to "nothing highlighted" so a message rendered outside the provider is unaffected.
 */
const ChatFindHighlightContext = createContext<ChatFindHighlightContextType>({
  highlightedMessageId: null,
  setHighlightedMessageId: () => undefined,
});

export const ChatFindHighlightProvider = ChatFindHighlightContext.Provider;

export const useChatFindHighlight = () => useContext(ChatFindHighlightContext);
